export const getNumberFromInput = (
  e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
) => {
  const value = e.target.value;
  if (value && Number.isFinite(+value)) return +value;
  return null;
};

export const getPlaceholderFromDefaultValues = (
  data: string | number | undefined | null,
  num?: number
): string => {
  if ((data || data === 0) && Number.isFinite(+data))
    return (+data).toFixed(num || 0);
  return '';
};
